const SvgEmail = () => <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 32 32">
    <path d="M29.333 8c0-1.467-1.2-2.667-2.667-2.667H5.333A2.675 2.675 0 0 0 2.666 8v16c0 1.467 1.2 2.667 2.667 2.667h21.333c1.467 0 2.667-1.2 2.667-2.667zM28 6.667 16 16 4 6.667zm0 18.666H4V8.666l12 9.333 12-9.333z" />
  </svg>;
export default SvgEmail;